import React from 'react'

export const ArrowRight = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="10">
    <path
      fillRule="evenodd"
      d="M14 5c0 .01-.005.017-.005.027a.956.956 0 0 1-.28.688c-.063.063-.139.099-.213.14l-3.86 3.86a.959.959 0 1 1-1.357-1.357L10.642 6H1a1 1 0 0 1 0-2h9.642L8.285 1.642A.959.959 0 1 1 9.642.285l3.856 3.856c.076.042.153.08.217.144a.956.956 0 0 1 .279.692c0 .009.006.015.006.023z"
    />
  </svg>
)
